<script>
import WideIconTile from '@/components/WideIconTile'
import ViewTitle from '@/components/ViewTitle'
import DOMUtils from '@/utils/DOMUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'

const REF_EDIT_MENU_INDEX_VIEW = 'edit-menu-index-view'

export default
{
    name: 'edit-menu-index',

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            if (LocalStorageUtils.useIntensiveAnimations)
            {
                let tiles = vm.editMenuIndexView.querySelectorAll('.tile')
                let delay = 0

                tiles.forEach(tile =>
                {
                    if (tile.style.display == 'none') return

                    tile.style.visibility = 'hidden'
                    setTimeout(() =>
                    {
                        tile.style.visibility = 'visible'
                        DOMUtils.animateCSS(tile, 'zoomIn', '0.2s')
                    }, delay)

                    delay += 50
                })
            }
        })
    },

    render () 
    {
        const features = EnvironmentUtils.cityFeatures

        const actualities = this.$store.state.actualities.actualityList
        const events = this.$store.state.events.eventList
        const pendingReports = this.$store.state.reports.reportsList.filter(r => r.tags.includes('pending'))
        const usefulInfos = this.$store.state.usefulInfos.infoList
        const lostObjects = this.$store.state.lostObjects.objectsList
        const lostPets = this.$store.state.lostPets.petsList
        const stores = this.$store.state.stores.storeList
        const adminAccounts = this.$store.getters.cities.getCityAdministratorsById(EnvironmentUtils.cityId)
        const adminAccountsLength = Object.keys(adminAccounts).length
        const userStore = this.$store.state.user.ownedStore && this.$store.getters.stores.getStoreById(this.$store.state.user.ownedStore.id)
        const userStoreCustomers = userStore && this.$store.state.storeLoyaltyCard.storeCustomers[userStore.id] || []
        const userStoreNotifsLeft = userStore && userStore.notificationQuota.left
        
        const actuEnding = actualities.length > 1 ? 's' : ''
        const eventsEnding = events.length > 1 ? 's' : ''
        const reportsEnding = pendingReports.length > 1 ? 's' : ''
        const usefulInfosEnding = usefulInfos.length > 1 ? 's' : ''
        const lostObjectsEnding = lostObjects.length > 1 ? 's' : ''
        const lostPetsEnding = lostPets.length > 1 ? 's' : ''
        const storesEnding = stores.length > 1 ? 's' : ''
        const accountsEnding = adminAccountsLength > 1 ? 's' : ''

        const user = this.$store.state.user
        const privileges = this.$store.getters.cities.getAccountPrivileges({ cityId: EnvironmentUtils.cityId, accountId: user.accountId })

        return (
            <div id='edit-menu-index' ref={REF_EDIT_MENU_INDEX_VIEW}>
                <view-title>Panel d'édition et d'administration</view-title>
                <div id='tiles-container'>
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('actualities')} title='actualités' v-show={privileges.canEditActualities}
                        subtitle={ `${actualities.length} actualité${actuEnding} publiée${actuEnding}` } icon={require('@/assets/img/newspaper.svg')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('events')} title='événements' v-show={privileges.canEditEvents}
                        subtitle={ `${events.length} événement${eventsEnding} programmé${eventsEnding}` } icon={require('@/assets/img/calendar.svg')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('reports')} title='signalements' v-show={features.hasReports && privileges.canManageReports}
                        subtitle={ `${pendingReports.length} signalement${reportsEnding} non traité${reportsEnding}` } icon={require('@/assets/img/alarm.svg')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('useful-info')} title='informations utiles' v-show={privileges.canEditUsefulInfos}
                        subtitle={ `${usefulInfos.length} information${usefulInfosEnding} publiée${usefulInfosEnding}` } icon={require('@/assets/img/agenda.svg')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('lost-objects')} title='Objets perdus' v-show={features.hasLostObjects && privileges.canManageLostObjects}
                        subtitle={ `${lostObjects.length} objet${lostObjectsEnding} signalé${lostObjectsEnding}` } icon={require('@/assets/img/objects-magnifier.svg')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('lost-pets')} title='Animaux perdus' v-show={features.hasLostPets && privileges.canManageLostPets}
                        subtitle={ `${lostPets.length} signalement${lostPetsEnding}` } icon={require('@/assets/img/girl-with-pet.png')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('stores')} title='Commerces' v-show={features.hasStores && privileges.canEditStores}
                        subtitle={ `${stores.length} commerce${storesEnding} référencé${storesEnding}` } icon={require('@/assets/img/store.svg')} />
                    {
                        user.ownedStore && features.hasStores &&
                        [
                            <WideIconTile class='tile' on-click={() => this.onTileClicked('stores/update/' + user.ownedStore.id)} title='Ma page'
                                subtitle={user.ownedStore.name} icon={require('@/assets/img/store.svg')} />,
                            <WideIconTile class='tile' on-click={() => this.onTileClicked('store-notifications/' + user.ownedStore.id)} title='Envoyer des notifications'
                                subtitle={`${userStoreNotifsLeft} notification${userStoreNotifsLeft > 1 ? 's' : ''} disponible${userStoreNotifsLeft > 1 ? 's' : ''}`}
                                icon={require('@/assets/img/mail.svg')} />
                        ]
                    }
                    {
                        user.ownedStore && features.hasLoyaltyCard &&
                        [
                            <WideIconTile class='tile' on-click={() => this.onTileClicked('loyalty-card/' + user.ownedStore.id)} title='Carte de fidélité'
                                subtitle={`${userStoreCustomers.length} clients enregistrés`} icon={require('@/assets/img/card.svg')} />,
                        ]
                    }
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('accounts')} title='comptes' v-show={privileges.canManageAccounts}
                        subtitle={ `${adminAccountsLength} compte${accountsEnding} adminstrateur` } icon={require('@/assets/img/girl.svg')} />
                    <WideIconTile class='tile' on-click={() => this.onTileClicked('notifications')} title='notifications' v-show={privileges.canManageNotifications}
                        icon={require('@/assets/img/mail.svg')} />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        editMenuIndexView ()
        {
            return this.$refs[REF_EDIT_MENU_INDEX_VIEW]
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onTileClicked (tileName)
        {
            this.$router.push({ path: tileName, append: true })
        },
    },

    components:
    {
        WideIconTile,
        ViewTitle
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#edit-menu-index
{
    .tile
    {
        
    }
}

</style>

<style lang='less'>
@import '~@/styles/main.less';

#edit-menu-index
{
    margin-top: 12vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 4vh);

    padding-left: 5vw;
    padding-right: 5vw;

    .OnTablet({
        padding-left: 10vw;
        padding-right: 10vw;
    });

    .OnDesktop({
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
        margin-top: 4vw;
    });

    #tiles-container
    {
        display: flex;
        flex-flow: column;

        .OnDesktop({
            flex-flow: row wrap;
            justify-content: space-between;
        });

        .tile
        {
            margin-bottom: 1.5vh;

            .OnDesktop({
                width: 22vw;
                margin-left: 2vw;
                margin-right: 2vw;
            });

            .title
            {
                font-weight: 500;

                .OnDesktop({ font-weight: 600; });
            }

            .icon-container
            {
                .OnTablet({ width: 12%; });
                .OnDesktop({ width: 15%; });
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/EditMenuIndex.vue